import { themeColors } from '../../themeColors';
/**
 * @file   src\components\AgentDashboard\ClientNotesModal.js
 * @brief  This file is responsible for adding client notes
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import TextArea from "../Common/TextArea";
import { FormLabel } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import {
  formateDate,
  trimString,
  upperCaseEachSentenceFirst,
} from "../../helpers/common";
import { handleTextBoxChange } from "../../actions/common";
import { toast } from "react-toastify";
import { textValidations } from "../../helpers/validations";
import { ERROR_TEXT } from "../../constants/common";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientNotesForExports } from "../../actions/agentClients";
import { getClientNoteListPdfExport } from "../../services/agentClientsService";
const ClientNotesModal = (props) => {
  const {
    show,
    onHide,
    clientName,
    clientId,
    loadClientNotes,
    notes,
    deleteNote,
    saveClientNote,
  } = props;
  const [currPage, setCurrPage] = useState(1);
  const [noteCharCount, setNoteCharCount] = useState(0);
  const [note, setNote] = useState("");
  const [isDisableButton, setDisable] = useState(true);
  const [isListUpdated, setListUpdated] = useState(false);
  const [descError, setDescError] = useState(null);
  const myRef = useRef(null);
  const dispatch = useDispatch();
  const clientNotesForexport = useSelector(
    (state) => state.agentClients.clientNotesForExport
  );
  const [notesExport, setNotesExport] = useState([]);
  const [clientNoteCursorPos, setClientNoteCursorPos] = useState(0);
  const clientNoteRef = useRef();

  useEffect(() => {
    loadClientNotes(currPage, isListUpdated);
  }, [currPage, isListUpdated == true]);
  useEffect(() => {
    window.addEventListener("scroll", handleScroll); // attaching scroll event listener
  }, []);

  useEffect(() => {
    if (clientNotesForexport && clientNotesForexport.length > 0) {
      setNotesExport(clientNotesForexport);
    } else {
      setNotesExport([]);
    }
  }, [clientNotesForexport]);

  const fetchNotesForExport = () => {
    dispatch(fetchClientNotesForExports(clientId));
  };

  useEffect(() => {
    fetchNotesForExport();
  }, [clientId]);

  useEffect(() => {
    if (note) {
      if (descError) {
        disableButton();
      }
      if (trimString(note) !== "" && textValidations(note)) {
        setDisable(false);
      } else {
        setDescError(ERROR_TEXT);
        disableButton();
      }
    } else {
      disableButton();
    }
  }, [note, descError]);

  const disableButton = () => {
    const isDisabled = true;
    setDisable(isDisabled);
  };

  /**
   * To add client note
   */
  const addClientNote = async () => {
    setListUpdated(false);
    const reqPayload = { clientId: clientId, note: note };
    const res = await saveClientNote(reqPayload);
    if (!_.get(res, "errorCode", "")) {
      const isListUpdated = true;
      const currPage = 1;
      loadClientNotes(currPage, isListUpdated);
      setNoteCharCount(0);
      setNote("");
      setDisable(true);
      fetchNotesForExport();
    }
  };

  /**
   * to delete client note
   * @param {*} reqPayload
   */
  const deleteClientNote = async (reqPayload) => {
    setListUpdated(false);
    const res = await deleteNote(reqPayload);
    if (!_.get(res, "errorCode", "")) {
      const isListUpdated = true;
      const currPage = 1;
      loadClientNotes(currPage, isListUpdated);
      fetchNotesForExport();
    }
  };

  /**
   * to handle scroll behaviour
   */

  const handleScroll = () => {
    const el = myRef.current;
    if (el) {
      const scrollHeight = el.scrollHeight;
      const scrollTop = el.scrollTop;
      const clientHeight = el.clientHeight;
      if (
        scrollHeight !== clientHeight &&
        scrollTop !== 0 &&
        Math.abs(scrollHeight - (scrollTop + clientHeight)) <= 1
      ) {
        setCurrPage((prevState) => prevState + 1);
      } else if (scrollTop === 0 && scrollHeight !== clientHeight) {
      }
    }
  };

  useEffect(() => {
    if (clientNoteRef.current) {
      clientNoteRef.current.setSelectionRange(
        clientNoteCursorPos,
        clientNoteCursorPos
      );
    }
  }, [clientNoteCursorPos]);

  /**
   * to handle note change
   * @param {*} e
   */
  const handleNoteChange = (e) => {
    setDescError(null);
    const value = upperCaseEachSentenceFirst(handleTextBoxChange(e));
    if (trimString(value) != "") {
      setClientNoteCursorPos(e.target.selectionStart);
    }

    setNoteCharCount(value.length);
    setNote(value);
  };

  const handleEnterPress = (event) => {
    if (event.key === "Enter") {
      //setNote(note+'\n')
    }
  };

  /**
   * to handle export notes functionality
   */
  const handleExportClientNotes = async () => {
    const payload = { clientId: clientId };
    await getClientNoteListPdfExport(payload).then((response) => {
      const result = _.get(response, "result", {});
      if (!result.status) {
        toast.error(result.message);
      }
    });
  };

  /**
   * to handle each note view
   * @param {*} props
   */
  function LoadNotes(props) {
    const { noteList } = props;
    return (
      <div className="client-notes-sec menu-position-fix" data-clarity-mask="true">
        <div className="flex-grow-1 long-txt-fix">
          <h6>{formateDate(_.get(noteList, "CreatedOn", ""))}</h6>
          <p className="notes-para long-txt-fix">
            {_.get(noteList, "Client_Notes", "")}
          </p>
        </div>
        <Dropdown>
          <Dropdown.Toggle
            id="dropdown-basic"
            className="more-notes-link"
            variant=""
            align="end"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 12.5C14 11.3954 13.1046 10.5 12 10.5C10.8954 10.5 10 11.3954 10 12.5C10 13.6046 10.8954 14.5 12 14.5C13.1046 14.5 14 13.6046 14 12.5Z"
                fill={themeColors.neutral780}
              />
              <path
                d="M14 7C14 5.89543 13.1046 5 12 5C10.8954 5 10 5.89543 10 7C10 8.10457 10.8954 9 12 9C13.1046 9 14 8.10457 14 7Z"
                fill={themeColors.neutral780}
              />
              <path
                d="M14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20C13.1046 20 14 19.1046 14 18Z"
                fill={themeColors.neutral780}
              />
            </svg>
          </Dropdown.Toggle>

          <Dropdown.Menu className="dpdown-menu-style" align={"end"}>
            <Dropdown.Item
              onClick={() =>
                deleteClientNote({
                  clientId: clientId,
                  noteId: _.get(noteList, "NoteId", ""),
                })
              }
            >
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.99979 1.6665C8.53799 1.6665 7.32079 2.75877 7.11649 4.1665H4.26574C4.23025 4.16043 4.19431 4.15744 4.15832 4.15755C4.12721 4.15822 4.0962 4.16122 4.06554 4.1665H2.70812C2.6253 4.16533 2.54307 4.18063 2.46622 4.21152C2.38936 4.2424 2.31941 4.28825 2.26043 4.3464C2.20145 4.40456 2.15462 4.47385 2.12265 4.55026C2.09068 4.62667 2.07422 4.70868 2.07422 4.7915C2.07422 4.87433 2.09068 4.95633 2.12265 5.03275C2.15462 5.10916 2.20145 5.17845 2.26043 5.2366C2.31941 5.29476 2.38936 5.34061 2.46622 5.37149C2.54307 5.40237 2.6253 5.41768 2.70812 5.4165H3.59923L4.64822 16.262C4.76117 17.4315 5.7547 18.3332 6.92931 18.3332H13.0694C14.2441 18.3332 15.2376 17.4316 15.3505 16.262L16.4003 5.4165H17.2915C17.3743 5.41768 17.4565 5.40237 17.5334 5.37149C17.6102 5.34061 17.6802 5.29476 17.7391 5.2366C17.7981 5.17845 17.845 5.10916 17.8769 5.03275C17.9089 4.95633 17.9254 4.87433 17.9254 4.7915C17.9254 4.70868 17.9089 4.62667 17.8769 4.55026C17.845 4.47385 17.7981 4.40456 17.7391 4.3464C17.6802 4.28825 17.6102 4.2424 17.5334 4.21152C17.4565 4.18063 17.3743 4.16533 17.2915 4.1665H15.9348C15.8685 4.15575 15.8009 4.15575 15.7346 4.1665H12.8831C12.6788 2.75877 11.4616 1.6665 9.99979 1.6665ZM9.99979 2.9165C10.7828 2.9165 11.4251 3.4449 11.6087 4.1665H8.3909C8.57447 3.4449 9.2168 2.9165 9.99979 2.9165ZM4.85412 5.4165H15.1446L14.1062 16.1416C14.0541 16.6812 13.6114 17.0832 13.0694 17.0832H6.92931C6.38809 17.0832 5.94458 16.6805 5.89253 16.1416L4.85412 5.4165ZM8.53169 7.49089C8.36607 7.49347 8.20825 7.56169 8.09289 7.68056C7.97754 7.79942 7.91408 7.95922 7.91645 8.12484V14.3748C7.91528 14.4577 7.93058 14.5399 7.96147 14.6167C7.99235 14.6936 8.0382 14.7635 8.09635 14.8225C8.15451 14.8815 8.2238 14.9283 8.30021 14.9603C8.37662 14.9923 8.45862 15.0087 8.54145 15.0087C8.62428 15.0087 8.70628 14.9923 8.78269 14.9603C8.85911 14.9283 8.9284 14.8815 8.98655 14.8225C9.04471 14.7635 9.09056 14.6936 9.12144 14.6167C9.15232 14.5399 9.16762 14.4577 9.16645 14.3748V8.12484C9.16765 8.04119 9.15205 7.95814 9.12056 7.88063C9.08908 7.80312 9.04235 7.73272 8.98316 7.6736C8.92396 7.61448 8.8535 7.56785 8.77595 7.53646C8.6984 7.50508 8.61534 7.48958 8.53169 7.49089ZM11.4484 7.49089C11.2827 7.49347 11.1249 7.56169 11.0096 7.68056C10.8942 7.79942 10.8307 7.95922 10.8331 8.12484V14.3748C10.8319 14.4577 10.8472 14.5399 10.8781 14.6167C10.909 14.6936 10.9549 14.7635 11.013 14.8225C11.0712 14.8815 11.1405 14.9283 11.2169 14.9603C11.2933 14.9923 11.3753 15.0087 11.4581 15.0087C11.5409 15.0087 11.623 14.9923 11.6994 14.9603C11.7758 14.9283 11.8451 14.8815 11.9032 14.8225C11.9614 14.7635 12.0072 14.6936 12.0381 14.6167C12.069 14.5399 12.0843 14.4577 12.0831 14.3748V8.12484C12.0843 8.04119 12.0687 7.95814 12.0372 7.88063C12.0057 7.80312 11.959 7.73272 11.8998 7.6736C11.8406 7.61448 11.7702 7.56785 11.6926 7.53646C11.6151 7.50508 11.532 7.48958 11.4484 7.49089Z"
                    fill={themeColors.neutral780}
                  />
                </svg>
              </span>
              Delete note
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }

  return (
    <Modal
      show={show}
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      className="client-notes-modal right"
    >
      <Modal.Body className="pt-32 pb-32" data-clarity-mask="true">
        <div className="client-notes-modal-top mb-2">
          <div className="flex-grow-1">
            <h3>Client notes: {clientName}</h3>
          </div>
          <button
            type="button"
            className="btn btn-slide-right flex-shrink-0"
            aria-label="Close"
            onClick={onHide}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.781 12.781L5.28104 20.281C5.14031 20.4218 4.94944 20.5008 4.75042 20.5008C4.55139 20.5008 4.36052 20.4218 4.21979 20.281C4.07906 20.1403 4 19.9494 4 19.7504C4 19.5514 4.07906 19.3605 4.21979 19.2198L11.1901 12.2504L4.21979 5.28104C4.07906 5.14031 4 4.94944 4 4.75042C4 4.55139 4.07906 4.36052 4.21979 4.21979C4.36052 4.07906 4.55139 4 4.75042 4C4.94944 4 5.14031 4.07906 5.28104 4.21979L12.781 11.7198C12.8508 11.7894 12.9061 11.8722 12.9438 11.9632C12.9816 12.0543 13.001 12.1519 13.001 12.2504C13.001 12.349 12.9816 12.4466 12.9438 12.5376C12.9061 12.6287 12.8508 12.7114 12.781 12.781ZM20.281 11.7198L12.781 4.21979C12.6403 4.07906 12.4494 4 12.2504 4C12.0514 4 11.8605 4.07906 11.7198 4.21979C11.5791 4.36052 11.5 4.55139 11.5 4.75042C11.5 4.94944 11.5791 5.14031 11.7198 5.28104L18.6901 12.2504L11.7198 19.2198C11.5791 19.3605 11.5 19.5514 11.5 19.7504C11.5 19.9494 11.5791 20.1403 11.7198 20.281C11.8605 20.4218 12.0514 20.5008 12.2504 20.5008C12.4494 20.5008 12.6403 20.4218 12.781 20.281L20.281 12.781C20.3508 12.7114 20.4061 12.6287 20.4438 12.5376C20.4816 12.4466 20.501 12.349 20.501 12.2504C20.501 12.1519 20.4816 12.0543 20.4438 11.9632C20.4061 11.8722 20.3508 11.7894 20.281 11.7198Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
        <a
          className="export-link"
          href={void 0}
          onClick={(e) => {
            handleExportClientNotes();
          }}
        >
          Export notes
        </a>

        <div className="wantad-des-wrap mt-3">
          <div className="position-relative">
            <FormLabel className="l-spacing-0">New note</FormLabel>

            <TextArea
              className="form-control txt-area"
              errorMessage={descError}
              maxLength={500}
              placeholder="Add new note here"
              value={note}
              onChange={handleNoteChange}
              onKeyDown={handleEnterPress}
              txtRef={clientNoteRef}
            />

            <div className="des-count mb-2">
              <span>{noteCharCount}</span>/<span>500</span>
            </div>
          </div>
        </div>
        <Button
          variant="primary"
          className="btn btn-delete"
          disabled={isDisableButton}
          onClick={() => addClientNote()}
        >
          Save note
        </Button>

        <div
          className="client-notes-wrap mt-4"
          onScroll={handleScroll}
          ref={myRef}
        >
          {notes?.map((note, i) => {
            return <LoadNotes noteList={note} />;
          })}
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ClientNotesModal;
